import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { observer } from 'mobx-react-lite';

import { MoreCtaButton } from '../../primitives/MoreCtaButton';

import externalLinkService from '~gateways/external-link';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_ThreeUp>;
  marginTop?: number;
};

export const ThreeUpMoreCta = observer(function ThreeUpMoreCta({
  gridCard,
  marginTop = 0,
}: Props) {
  const data = gridCard.data!;
  const { textProps, boxSize: size } = data.styles!.textPart.moreCta;

  const onClick = () => {
    externalLinkService.openUrl(data.dtoData.linkButtonUrl);
  };

  return (
    <MoreCtaButton
      textProps={textProps}
      size={size}
      marginTop={marginTop}
      onClick={onClick}
      radius={45}
    />
  );
});
